import { Link } from "react-router-dom";
import { BrandLogo } from "@/components/BrandLogo";

const LEGAL = [
  { to: "/legal/terms-of-use",        label: "Master Agreement" },
  { to: "/legal/privacy-policy",      label: "Privacy & Data" },
  { to: "/legal/recording-policy",    label: "Capture Restrictions" },
  { to: "/legal/investor-disclaimer", label: "Investor Access" },
  { to: "/legal/ai-protection",       label: "AI & Trade Secrets" },
  { to: "/legal/risk-disclaimer",     label: "Dispute & Enforcement" },
];

export function Footer() {
  return (
    <footer className="py-12 bg-[#050A07] border-t border-[#1A2E22]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
          <div>
            <div className="mb-2">
              <BrandLogo size="md" />
            </div>
            <p className="text-[#A1B2A8]/60 text-xs leading-relaxed max-w-sm">
              Operating Infrastructure for the $8T+ global food trade.
            </p>
          </div>

          <div>
            <p className="text-[#A1B2A8] text-[10px] uppercase tracking-[0.2em] font-semibold mb-3">Explore</p>
            <ul className="space-y-2">
              <li><a href="#what-is" className="text-sm text-[#A1B2A8] hover:text-white transition-colors">What is GreenX</a></li>
              <li><a href="#ai-engine" className="text-sm text-[#A1B2A8] hover:text-white transition-colors">AI Engine</a></li>
              <li><a href="#market-reality" className="text-sm text-[#A1B2A8] hover:text-white transition-colors">Market</a></li>
              <li><a href="#how-it-works" className="text-sm text-[#A1B2A8] hover:text-white transition-colors">How It Works</a></li>
            </ul>
          </div>

          <div>
            <p className="text-[#A1B2A8] text-[10px] uppercase tracking-[0.2em] font-semibold mb-3">Legal</p>
            <ul className="space-y-2" data-testid="footer-legal-links">
              {LEGAL.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-[#A1B2A8] hover:text-white transition-colors"
                    data-testid={`footer-${l.to.split("/").pop()}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <a href="mailto:legal@deltagreenx.com" className="text-sm text-[#22C55E]/80 hover:text-[#22C55E] transition-colors">
                  legal@deltagreenx.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-[#1A2E22] flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[#A1B2A8]/50 text-xs">
            &copy; {new Date().getFullYear()} Delta GreenX. All rights reserved.
          </p>
          <p className="text-[#A1B2A8]/40 text-[10px] italic">
            Operating infrastructure · technology platform · not a bank, lender, or investment advisor.
          </p>
        </div>
      </div>
    </footer>
  );
}
